// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleDetailsPage_page__nsKlT {
  width: 100%;
  min-width: 0;
}

.ScheduleDetailsPage_backButton__sE0Ep {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-height: 2.35rem;
  margin-top: 1rem;
  padding: 0 0.8rem;
  color: #344054;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 800;
  background: #ffffff;
  border: 1px solid #dbe2ea;
  border-radius: 0.6rem;
  cursor: pointer;
}

.ScheduleDetailsPage_backButton__sE0Ep:hover {
  color: #1d4ed8;
  background: #f7faff;
  border-color: #b9ccf5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ScheduleDetails/ScheduleDetailsPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".page {\n  width: 100%;\n  min-width: 0;\n}\n\n.backButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-height: 2.35rem;\n  margin-top: 1rem;\n  padding: 0 0.8rem;\n  color: #344054;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 800;\n  background: #ffffff;\n  border: 1px solid #dbe2ea;\n  border-radius: 0.6rem;\n  cursor: pointer;\n}\n\n.backButton:hover {\n  color: #1d4ed8;\n  background: #f7faff;\n  border-color: #b9ccf5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ScheduleDetailsPage_page__nsKlT`,
	"backButton": `ScheduleDetailsPage_backButton__sE0Ep`
};
export default ___CSS_LOADER_EXPORT___;
